import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  reportsDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';

import controller from './bulk-delete-archived-report-instance.controller';
import directive from './bulk-delete-archived-report-instance.directive';

export default angular.module('app.components.reports.archivedReports.reportType.bulkDeleteArchivedReportInstance', [
    alerts,
    actionIcon,
    confirmDialog,
    loaderService,
    ssDialogService,
    reportsDataService,
  ])
  .directive('bulkDeleteArchivedReportInstance', directive)
  .controller('BulkDeleteArchivedReportInstanceController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportType.bulkDeleteArchivedReportInstance created');
